import React, { Fragment } from 'react';
import './App.css';
import Navbar from './components/layout/Navbar';
import Alert from './components/layout/alert';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Switch } from 'react-router-dom';
import About from './components/pages/about';
import User from './components/users/User';
import GithubState from './context/github/GithubState';
import AlertState from './context/alert/AlertState';
import { Home } from './components/pages/Home';
import { NotFound } from './components/pages/NotFound';

const App = () => {
  return (
    <Fragment>
      <GithubState>
        <AlertState>
          <Router>
            <div className='navbar bg-primary'>
              <Navbar title='Github Finder' />
            </div>
            <div className='container'>
              <Alert />
              <Switch>
                <Route exact path='/' component={Home} />
                <Route path='/about'>
                  <About />
                </Route>
                <Route exact path='/user/:login' component={User} />
                <Route component={NotFound} />
              </Switch>
            </div>
          </Router>
        </AlertState>
      </GithubState>
    </Fragment>
  );
};

export default App;
